/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FieldRequireTypes,
    FieldRequireTypesFromJSON,
    FieldRequireTypesFromJSONTyped,
    FieldRequireTypesToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureStatus
 */
export interface FailureStatus {
    /**
     * 
     * @type {string}
     * @memberof FailureStatus
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureStatus
     */
    alternativeName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatus
     */
    isSpecialCase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatus
     */
    isSealed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatus
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FailureStatus
     */
    requiresWorkbookTask?: boolean;
    /**
     * 
     * @type {FieldRequireTypes}
     * @memberof FailureStatus
     */
    requiresStateChangeReason?: FieldRequireTypes;
    /**
     * 
     * @type {string}
     * @memberof FailureStatus
     */
    id?: string;
}

export function FailureStatusFromJSON(json: any): FailureStatus {
    return FailureStatusFromJSONTyped(json, false);
}

export function FailureStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'alternativeName': !exists(json, 'alternativeName') ? undefined : json['alternativeName'],
        'isSpecialCase': !exists(json, 'isSpecialCase') ? undefined : json['isSpecialCase'],
        'isSealed': !exists(json, 'isSealed') ? undefined : json['isSealed'],
        'isDefault': !exists(json, 'isDefault') ? undefined : json['isDefault'],
        'requiresWorkbookTask': !exists(json, 'requiresWorkbookTask') ? undefined : json['requiresWorkbookTask'],
        'requiresStateChangeReason': !exists(json, 'requiresStateChangeReason') ? undefined : FieldRequireTypesFromJSON(json['requiresStateChangeReason']),
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function FailureStatusToJSON(value?: FailureStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'alternativeName': value.alternativeName,
        'isSpecialCase': value.isSpecialCase,
        'isSealed': value.isSealed,
        'isDefault': value.isDefault,
        'requiresWorkbookTask': value.requiresWorkbookTask,
        'requiresStateChangeReason': FieldRequireTypesToJSON(value.requiresStateChangeReason),
        'id': value.id,
    };
}


